<template>
    <td>
        <div v-if="location?.area">{{ location.area }}</div>
        <div v-if="location?.subArea">{{ location.subArea }}</div>
    </td>
</template>
<script setup>
const props = defineProps({
    location: Object,
});
</script>
